<template>
  <div class="index-section">
    <Header ref="Headers" />

    <div class="tab-new tes">
      <van-tabs v-model="active">
        <van-tab title="省总领导">
          <UnionOverviewNewsListWithSubtitle :is-show-time="false" :data="list" />
        </van-tab>
      </van-tabs>
    </div>
    
    <div class="tab-new tes1">
      <van-tabs v-model="active1">
        <van-tab title="省总简介">
          <UnionOverviewNewsList ref="dataliets1" :is-show-time="false" :data="firstItem1" />
        </van-tab>
        <van-tab title="主要职责">
          <UnionOverviewNewsList ref="dataliets2" :is-show-time="false" :data="firstItem2" />
        </van-tab>
      </van-tabs>
    </div>
    
    <div class="tab-new tes">
      <van-tabs v-model="active2">
        <van-tab title="组织机构">
          <UnionOverviewNewsList ref="dataliets" :is-show-time="false" :data="firstItem3" />
        </van-tab>
      </van-tabs>
    </div>
    
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/footer.vue";
import Header from "@/components/header.vue";
import { get } from "@/request/http";
import UnionOverviewNewsList from "@/components/UnionOverviewNewsList.vue";
import UnionOverviewNewsListWithSubtitle from "@/components/UnionOverviewNewsListWithSubtitle.vue";

export default {
  components: {
    UnionOverviewNewsList,
    UnionOverviewNewsListWithSubtitle,
    Header,
    Footer
  },
  
  data() {
    return {
      active: 0,
      active1: 0,
      active2: 0,
      firstList: [],
      list: [],
      limit: -1,
      page: 1,
      total: 0,
      loading: true,
      firstItem1: [],
      firstItem2: [],
      firstItem3: [],
      // 页面所需的分类ID
      categoryIds: {
        leadership: '50602',
        introduction: '50601', 
        responsibility: '50604',
        organization: '50603'
      }
    };
  },
  
  activated() {
    this.$refs.Headers.switchTab(2);
    this.fetchLeadership();
    this.fetchCategoryData('introduction', 'firstItem1');
    this.fetchCategoryData('responsibility', 'firstItem2');
    this.fetchCategoryData('organization', 'firstItem3');
  },
  
  methods: {
    // 获取领导数据（需特殊处理，与其他数据不同）
    fetchLeadership() {
      this.fetchData(this.categoryIds.leadership, (list) => {
        this.firstList = list.slice(0, 1);
        this.list = list.slice(1);
      });
    },
    
    // 获取其他分类数据
    fetchCategoryData(type, targetProperty) {
      this.fetchData(this.categoryIds[type], (list) => {
        this[targetProperty] = list;
      });
    },
    
    // 通用数据获取方法
    fetchData(categoryId, callback) {
      this.loading = true;
      
      get(`/gbs/portal/portal/newsPage`, {
        limit: this.limit,
        page: this.page,
        categoryId,
        title: ''
      })
        .then((res) => {
          this.loading = false;
          
          if (res.code !== 0) {
            this.$message.error(res.msg || '获取数据失败');
            return;
          }
          
          const list = res.data.list || res.data;
          callback(list);
          
          if (res.data.total !== undefined) {
            this.total = res.data.total;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error('网络请求异常');
          console.error('数据获取失败:', err);
        });
    }
  }
};
</script>

<style scoped lang="scss">
.index-section {
  background: #ffffff;
  position: relative;
  min-height: 100vh;
}

.custom-indicator {
  position: absolute;
  height: 78px;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px 5px;

  .title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 90%;
  }

  span {
    font-size: 24px;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: 400;
    color: #ffffff;
    line-height: 28px;
    text-align: left;
  }
}

.swiper-section {
  position: relative;
  width: 100%;
  height: 420px;

  .pic {
    width: 100%;
    height: 100%;
  }
}

.title-new {
  margin: 10px auto;
  position: relative;
  width: 95%;
  height: 50px;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: 500;
  font-size: 32px;
  color: #c90c0c;
  line-height: 38px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tab-new {
  margin: 45px auto;
  position: relative;
  width: 100%;

  ::v-deep .van-tabs__wrap {
    position: relative;
    width: 75%;
  }

  ::v-deep .van-tabs__nav {
    margin: 0;
  }

  .more {
    width: fit-content;
    position: absolute;
    top: 18px;
    right: 4px;
    font-size: 28px;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: 500;
    color: #000000;
    line-height: 30px;
    text-align: right !important;
    margin-top: 12px;
  }
}

.tes {
  ::v-deep .van-tabs__wrap {
    position: relative;
    width: 22%;
  }

  ::v-deep .van-tabs__nav {
    margin: 0;
  }
}

.tes1 {
  ::v-deep .van-tabs__wrap {
    position: relative;
    width: 44%;
  }

  ::v-deep .van-tabs__nav {
    margin: 0;
  }
}

.hot-topics {
  margin: 10px auto;
  position: relative;
  width: 100%;
  height: 200px;
  display: flex;
  flex-direction: column;

  .hot-title {
    margin: 0 auto;
    width: 95%;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .more-btn {
      display: flex;
      align-items: center;

      .more {
        font-weight: 400;
        font-size: 24px;
        color: #000000;
        line-height: 28px;
      }

      img {
        margin-left: 10px;
        width: 15px;
        height: 24px;
      }
    }

    span {
      font-weight: 600;
      font-size: 36px;
      color: #000000;
      line-height: 42px;
    }
  }

  .hot-img {
    width: 95%;
    height: 140px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    overflow: scroll;

    img {
      margin: 10px;
      width: 333px;
      height: 120px;
    }
  }
}

::v-deep .van-tab--active .van-tab__text {
  color: #ee0a24;
  font-weight: 600;
}

::v-deep .van-tab__text {
  font-weight: 600;
}
</style>